import { createSelector } from '@ngrx/store';
import { getDragonflyState } from '../reducers';

export const getEliquaCXConfigurationState = createSelector(getDragonflyState, (state) => state?.eliquaCXConfiguration);

export const getNameEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.nameEliquaCX ? state.nameEliquaCX.trim() : '',
);
export const getIntegrationCodeEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.integrationCodeEliquaCX ? state.integrationCodeEliquaCX.trim() : '',
);
export const getStatusEliquaCX = createSelector(getEliquaCXConfigurationState, (state) => state?.isActiveEliquaCX);
export const getSchemaCodeEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.schemaCodeEliquaCX ? state.schemaCodeEliquaCX.trim() : '',
);
export const getIdpAccountEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.idpAccountEliquaCX ? state.idpAccountEliquaCX.trim() : '',
);
export const getBaseURLEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.baseUrlEliquaCX ? state.baseUrlEliquaCX.trim() : '',
);
export const getUsernameEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.usernameEliquaCX ? state.usernameEliquaCX.trim() : '',
);
export const getPasswordEliquaCX = createSelector(getEliquaCXConfigurationState, (state) =>
  state?.passwordEliquaCX ? state.passwordEliquaCX.trim() : '',
);
export const getDisableNameValue = createSelector(getEliquaCXConfigurationState, (state) => state?.disableName);
export const getDisableIntegrationCodeValue = createSelector(
  getEliquaCXConfigurationState,
  (state) => state?.disableIntegrationCode,
);

export const getShowUpdateBtn = createSelector(getEliquaCXConfigurationState, (state) => state?.showUpdateBtn);
export const getShowCancelBtn = createSelector(getEliquaCXConfigurationState, (state) => state?.showCancelBtn);

export const getRootConfigurationHelpTextStatus = createSelector(
  getEliquaCXConfigurationState,
  (state) => state?.rootConfigurationHelpTextStatus,
);

export const getCredentialsConfigurationHelpTextStatus = createSelector(
  getEliquaCXConfigurationState,
  (state) => state?.credentialsConfigurationHelpTextStatus,
);
export const getEndpointConfigurationHelpTextStatus = createSelector(
  getEliquaCXConfigurationState,
  (state) => state?.endpointConfigurationHelpTextStatus,
);

export const getSelectedEliquaCXDataFromGrid = createSelector(
  getEliquaCXConfigurationState,
  (state) => state?.selectedEliquaCXDataFromGrid,
);

export const getEliquaCXDataIsSubmitted = createSelector(
  getEliquaCXConfigurationState,
  (state) => state?.isSubmittedData,
);

export const getShowNameErrorMsg = createSelector(
  getNameEliquaCX,
  getEliquaCXDataIsSubmitted,
  (name, dataIsSubmitted) => (!name && dataIsSubmitted ? true : false),
);
export const getShowIntegrationCodeErrorMsg = createSelector(
  getIntegrationCodeEliquaCX,
  getEliquaCXDataIsSubmitted,
  (code, dataIsSubmitted) => (!code && dataIsSubmitted ? true : false),
);
export const getShowSchemaCodeErrorMsg = createSelector(
  getSchemaCodeEliquaCX,
  getEliquaCXDataIsSubmitted,
  (schemaCode, dataIsSubmitted) => (!schemaCode && dataIsSubmitted ? true : false),
);
export const getShowIdpAccountErrorMsg = createSelector(
  getIdpAccountEliquaCX,
  getEliquaCXDataIsSubmitted,
  (idpAccount, dataIsSubmitted) => (!idpAccount && dataIsSubmitted ? true : false),
);
export const getShowBaseUrlErrorMsg = createSelector(
  getBaseURLEliquaCX,
  getEliquaCXDataIsSubmitted,
  (url, dataIsSubmitted) => (!url && dataIsSubmitted ? true : false),
);
export const getShowUsernameErrorMsg = createSelector(
  getUsernameEliquaCX,
  getEliquaCXDataIsSubmitted,
  (username, dataIsSubmitted) => (!username && dataIsSubmitted ? true : false),
);
export const getShowPasswordErrorMsg = createSelector(
  getPasswordEliquaCX,
  getEliquaCXDataIsSubmitted,
  getShowUpdateBtn,
  (password, dataIsSubmitted, isEditMode) => (!password && dataIsSubmitted && !isEditMode ? true : false),
);

export const getValidationInputs = createSelector(
  getNameEliquaCX,
  getIntegrationCodeEliquaCX,
  getSchemaCodeEliquaCX,
  getIdpAccountEliquaCX,
  getBaseURLEliquaCX,
  getUsernameEliquaCX,
  getPasswordEliquaCX,
  getShowNameErrorMsg,
  getShowIntegrationCodeErrorMsg,
  getShowSchemaCodeErrorMsg,
  getShowIdpAccountErrorMsg,
  getShowBaseUrlErrorMsg,
  getShowUsernameErrorMsg,
  getShowPasswordErrorMsg,
  (
    name,
    code,
    schemaCode,
    idpAccount,
    baseURL,
    username,
    password,
    nameErr,
    codeErr,
    schemaCodeErr,
    idpAccountErr,
    baseURLErr,
    usernameErr,
    passwordErr,
  ) => ({
    name,
    code,
    schemaCode,
    idpAccount,
    baseURL,
    username,
    password,
    nameErr,
    codeErr,
    schemaCodeErr,
    idpAccountErr,
    baseURLErr,
    usernameErr,
    passwordErr,
  }),
);

export const getEliquaCXDataIsValid = createSelector(getValidationInputs, getShowUpdateBtn, (inputs, isEditMode) => {
  const allFieldsHaveValue =
    !!inputs.name &&
    !!inputs.code &&
    !!inputs.schemaCode &&
    !!inputs.idpAccount &&
    !!inputs.baseURL &&
    !!inputs.username &&
    (!!inputs.password || isEditMode);

  const noValidationErrors =
    !inputs.nameErr &&
    !inputs.codeErr &&
    !inputs.schemaCodeErr &&
    !inputs.idpAccountErr &&
    !inputs.baseURLErr &&
    !inputs.usernameErr &&
    !inputs.passwordErr;

  return allFieldsHaveValue && noValidationErrors;
});
